import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@src/environments';
import { Observable } from 'rxjs';

export interface VerifyDecedentPayload {
  firstName: string;
  lastName: string;
  ssn_private: string;
  zipCode: string;
  dateOfBirth: string;
}

export interface VerifyDecedentResponse {
  verifiedDeceased: boolean;
  recentDecedentPoid: string;
  multiplePoids: boolean;
  inheritanceWaiverState: string;
}

@Injectable({
  providedIn: 'root',
})

/*
 * Verify if decedent has passed away using the client-search-by-tin middleware
 */
export class VerifyDecedentService {
  constructor(private http: HttpClient) {}

  /**
   * Calls client-search-by-tin middleware service and returns deceased boolean
   * @param verifyDecedentPayload - Info gathered from the decedent info page
   */
  verifyDecedent(verifyDecedentPayload: VerifyDecedentPayload): Observable<VerifyDecedentResponse> {
    return this.http.post<VerifyDecedentResponse>(`secure/verify-decedent`, verifyDecedentPayload);
  }
}
